<template>
  <el-form class="step-one" label-width="100px" label-position="left" ref="verify" :model="verify" :rules="rules">
    <el-form-item label="手机号:" prop="phoneNumber">
      <el-input v-focus v-model="verify.phoneNumber" @input="checkNull" placeholder="请输入手机号"></el-input>
    </el-form-item>
    <el-form-item class="img-code" label="图片验证码:" prop="imageCode">
      <image-verify-code ref='verifyImg' v-model="verify.imageCode" prop="imageCode" @input="updateImgCode" />
    </el-form-item>
    <el-form-item class="verification" label="短信验证码:" prop="message">
      <el-input v-model="verify.message" @input="checkMessage" placeholder="请输入短信验证码"></el-input>
      <el-button type="primary" :disabled="waitToGet" @click="getVerification">{{count}}{{tips}}</el-button>
    </el-form-item>
    <el-form-item>
      <el-button style="margin-top: 12px;" :disabled="canNext" type="primary" @click="next('verify')">下一步</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import ImageVerifyCode from '../image-verify-code.vue'
import CookieOperation from '@/plugins/cookie'
export default {
  name: 'authentication',
  components: {
    ImageVerifyCode
  },
  data () {
    let phoneNumberRules = (rule, value, callback) => {
      let reg = /^[0-9]*$/
      if (reg.test(value) === false) {
        this.verify.phoneNumber = ''
      }
    }
    return {
      tenantId: '',
      verify: {
        phoneNumber: '',
        imageCode: '',
        message: ''
      },
      waitToGet: true,
      canNext: true,
      count: '获取验证码',
      tips: '',
      active: 0,
      rules: {
        phoneNumber: [{
          pattern: /^1[3-9][0-9]{9}$/,
          required: true,
          message: '请输入正确的手机号',
          trigger: 'blur'
        },
        {
          validator: phoneNumberRules,
          trigger: 'change'
        }],
        message: [{
          required: true,
          message: '请输入短信验证码',
          trigger: 'blur'
        }],
        imageCode: [{
          required: true,
          message: '请输入图片验证码',
          trigger: 'blur'
        }]
      }
    }
  },
  created () {
    this.tenantId = CookieOperation.get('tenantId')
  },
  methods: {
    checkNull () {
      if (this.verify.phoneNumber) {
        this.waitToGet = false
      }
    },
    checkMessage () {
      if (this.verify.message && this.verify.phoneNumber) {
        this.canNext = false
      }
    },
    getVerification () {
      let that = this
      if (!that.verify.phoneNumber) {
        that.$message.error('请输入手机号')
        return
      } else if (!that.verify.imageCode) {
        that.$message.error('请输入图片验证码')
        return
      }
      this.$axios.get('/auth-api/login/no-auth/getTelCode',
        {
          headers: {'tenantId': that.tenantId},
          params: {
            'imgCode': that.verify.imageCode,
            'type': '2',
            'telephone': that.verify.phoneNumber,
            'tenantId': that.tenantId
          }
        }
      )
        .then((res) => {
          this.count = 60
          this.tips = '秒后重新获取'
          this.waitToGet = true
          let timer = setInterval(() => {
            this.count--
            if (this.count === 0) {
              clearInterval(timer)
              this.waitToGet = false
              this.tips = ''
              this.count = '重新获取验证码'
            }
          }, 1000)
        })
    },
    updateImgCode (value) {
      this.imageCode = value
    },
    next (formName) {
      if (!this.verify.phoneNumber) {
        this.$message.error('请输入手机号')
        return
      } else if (!this.verify.imageCode) {
        this.$message.error('请输入图片验证码')
        return
      } else if (!this.verify.message) {
        this.$message.error('请输入短信验证码')
        return
      }
      this.$axios.get('/auth-api/login/no-auth/validateMessageCode', {
        headers: {
          'tenantId': this.tenantId
        },
        params: {
          'telephone': this.verify.phoneNumber,
          'telCode': this.verify.message,
          'serviceType': '2',
          'tenantId': this.tenantId
        }
      })
        .then((res) => {
          if (res.data === true) {
            this.active++
            this.$emit('sendValueToParent', this.verify.phoneNumber, this.verify.message)
            this.$emit('next', this.active)
          }
        })
    }
  }
}

</script>

<style lang="scss" scope>
  @import "@/assets/scss/common.scss";

  .content {
    position: relative;
  }

  .step-one {
    input.el-input__inner {
      height: 38px;
    }

    .img-code{
      .el-form-item{
        margin-bottom: 0;
      }
    }

    .image-verify-code {

      .img-code>input {
        width: 194px;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        -webkit-appearance: none;
        background-color: #fff;
        background-image: none;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
      }

      .verify-img {
        margin-left: 12px;
      }
    }

    .verification {
      .el-input {
        width: 194px;
        margin-right: 10px;
      }

      .el-button {
        float: right;
        width: 120px;
        height: 38px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/system/forgetPassword/authentication.vue